import type { SVGProps } from "react";

export default function SolarCalendarDateLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M2 12C2 8.229 2 6.343 3.172 5.172S6.229 4 10 4h4c3.771 0 5.657 0 6.828 1.172S22 8.229 22 12v2c0 3.771 0 5.657-1.172 6.828S17.771 22 14 22h-4c-3.771 0-5.657 0-6.828-1.172S2 17.771 2 14z" />
        <path strokeLinecap="round" d="M7 4V2.5M17 4V2.5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m9 14.5 1.5-1.5v4" />
        <path strokeLinecap="round" d="M13 16v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0" />
        <path strokeLinecap="round" d="M2.5 9h19" />
      </g>
    </svg>
  );
}
